function magnify(image) {
  const overlay = document.createElement('div');
  overlay.className = 'image-fullscreen-overlay';

  const fullImage = document.createElement('img');
  fullImage.src = image.src;
  fullImage.className = 'image-fullscreen';

  overlay.appendChild(fullImage);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden'; // Prevent scroll in background

  let zoomLevel = 1;

  // Toggle zoom on image click
  fullImage.addEventListener('click', (e) => {
    e.stopPropagation(); // Prevent overlay from closing
    zoomLevel = zoomLevel === 1 ? 2 : 1;
    fullImage.style.transform = `scale(${zoomLevel})`;
    fullImage.style.cursor = zoomLevel === 1 ? 'zoom-in' : 'zoom-out';
  });

  // Close overlay on background click
  overlay.addEventListener('click', () => {
    overlay.remove();
    document.body.style.overflow = '';
  });
}

// Enable click-to-magnify for all images with this class
function enableFullscreenOnClick() {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.addEventListener('click', () => magnify(image));

    // Mobile support for tap without scroll conflict
    let startY = 0, moved = false;

    image.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) return;
      startY = e.touches[0].clientY;
      moved = false;
    });

    image.addEventListener('touchmove', (e) => {
      if (Math.abs(e.touches[0].clientY - startY) > 10) moved = true;
    });

    image.addEventListener('touchend', (e) => {
      if (!moved) {
        e.preventDefault();
        magnify(image);
      }
    });
  });
}

enableFullscreenOnClick();
